<template>
  <div>
    <HeaderPage href="/about" />
    <div class="container_wrap">
      <div class="neiBanner">
        <div class="textBanner wow" data-animate="fadeInUp">
          <dl>国正安全技术</dl>
          <dt>正念 / 正心 / 正言 / 正行</dt>
        </div>
      </div>
      <div>
        <div class="about wow" data-animate="fadeInRight">
          <div class="wrap">
            <div class="ntitle">
              <h3>INSTITUTIONAL PROFILE</h3>
              <h2>公司简介</h2>
            </div>
            <div class="text">
              <b>浙江国正安全技术有限公司</b>位于浙江省绍兴市柯桥区齐贤镇高泽镜水路1906号物流大厦，是一家以安全评价、职业卫生检测与评价、环境保护检测和安全生产技术服务为主体的综合类高新技术企业，具有独立的法人资格。
              <br />公司办公面积2256㎡。
              <br />公司内设安全评价部、职业健康事业部、环境事业部、电子电气事业部、质量管理部、安全技术服务事业部、市场营销部、理化分析中心、财务部和综合办。
              <br />公司现拥有一批经验丰富、富有活力的员工团队，拥有健全的内部管理制度和保密制度，现有建材、化工、机械、电气、消防、矿山、冶金、仪表、土木、职业卫生、安全等专业的技术人员85人。
              <br />公司是经浙江省应急管理厅批准的安全评价机构，证书编号为APJ-(浙)-007。
              <br />是经浙江省生态环境厅、绍兴市生态环境局认可的社会环境检测机构。
              <br />是经浙江省卫生健康委员会批准的职业卫生技术服务机构，证书编号为浙（08）卫职技字（2016）第002号，通过计量认证检测项目千余项。
              <br />公司现有人员熟悉企业管理工作流程，具有丰富的企业安全管理技术和工作经验，以其规范、科学、严谨的工作态度为客户提供务实、高效的安全生产技术服务。
              <br />浙江国正安全技术有限公司是一家受社会尊敬、让员工自豪、新时代一流的高新技术企业。
            </div>
          </div>

        </div>
      </div>
    </div>
    <FooterPage />
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
// 组件逻辑
import HeaderPage from '@/components/HeaderPage.vue'
import FooterPage from '@/components/FooterPage.vue'

let intervalId


const stopAutoScroll = () => {
  clearInterval(intervalId)
}

onMounted(() => {

  // ✅ 滚动动画逻辑
  const elements = document.querySelectorAll('.wow')
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry.target
        const animateName = el.dataset.animate || 'fadeInUp'
        if (entry.isIntersecting) {
          el.classList.add('animated', animateName)
          // ✅ 添加后立即取消观察，避免重复触发
          observer.unobserve(el)
        }
      })
    },
    { threshold: 0.2 }
  )
  elements.forEach((el) => observer.observe(el))
  onUnmounted(() => {
    elements.forEach((el) => observer.unobserve(el))
    stopAutoScroll()
  })
})

</script>

<style scoped>
/* 动画基础样式 */
.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

@keyframes fadeInUp {
  from {
    transform: translate3d(0, 100%, 0);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.fadeInUp {
  animation-name: fadeInUp;
}

@-webkit-keyframes fadeInRight {
  0% {
    opacity: 0;
    -webkit-transform: translateX(20px);
    transform: translateX(20px)
  }

  100% {
    opacity: 1;
    -webkit-transform: translateX(0);
    transform: translateX(0)
  }
}

@keyframes fadeInRight {
  0% {
    opacity: 0;
    -webkit-transform: translateX(20px);
    -ms-transform: translateX(20px);
    transform: translateX(20px)
  }

  100% {
    opacity: 1;
    -webkit-transform: translateX(0);
    -ms-transform: translateX(0);
    transform: translateX(0)
  }
}

.fadeInRight {
  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight
}

.neiBanner {
  height: 640px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: url('@/assets/about.jpg');
}

.neiBanner .textBanner {
  color: #fff;
  text-align: center;
  font-weight: bold;
}

.neiBanner .textBanner dl {
  font-size: 72px;
}

.neiBanner .textBanner dt {
  font-size: 30px;
  font-weight: 500;
}

.about {
  padding: 65px 0 70px;
}

.about .wrap {
  width: 1680px;
  margin: 0 auto;
}

.about .ntitle h3 {
  font-size: 36px;
  line-height: 1;
  color: #003366;
  font-weight: 500;
  border-bottom: #003366 solid 1px;
  display: inline-block;
  padding: 0 0 15px;
  margin-bottom: 15px;
}

.about .ntitle h2 {
  font-size: 30px;
  line-height: 1;
  color: #333;
  font-weight: 500;
}

.about .text {
  padding: 60px 0;
  line-height: 2;
  color: #666;
}

.about .text p {
  line-height: 30px;
}
</style>